import api, { getApiData, normalizeUsername, toArray } from '../utils/api';

export async function getProfile(username) {
  const normalizedUsername = normalizeUsername(username);
  const params = normalizedUsername ? { params: { username: normalizedUsername } } : {};
  const response = await api.get('/profile', params);
  return getApiData(response, null);
}

export async function updateProfile(targetUsername, updates) {
  const normalizedUsername = normalizeUsername(targetUsername);
  const response = await api.put('/profile', {
    target_username: normalizedUsername || undefined,
    updates: updates && typeof updates === 'object' ? updates : {},
  });
  return getApiData(response, null);
}

export async function getEmployees() {
  const response = await api.get('/employees');
  return toArray(getApiData(response, []));
}
